module.exports = __webpack_public_path__ + "img/lorena.4801bc9.webp";